import { post } from "../HttpService";

export class SecureService {
  static submit = (queryData = {}, config = {}) => {
    return post(`devices`, queryData, config);
  };
}
